<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Создать новый семестр</h4>
            </div>
            <div class="card-body">
              <div v-if="successMessage" class="alert alert-success"><span>{{ successMessage }}</span></div>
              <div v-if="errorMessage" class="alert alert-danger"><span>{{ errorMessage }}</span></div>

              <form @submit.prevent="createSemester">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Название семестра</label>
                      <input type="text" class="form-control" v-model="form.name" placeholder="Например: Осенний семестр 2025/2026" required>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Дата начала</label>
                      <input type="date" class="form-control" v-model="form.startDate" required>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Дата окончания</label>
                      <input type="date" class="form-control" v-model="form.endDate" required>
                    </div>
                  </div>
                </div>
                <button type="submit" class="btn btn-success btn-fill pull-right" :disabled="loading">
                  {{ loading ? 'Сохранение...' : '+ Добавить семестр' }}
                </button>
                <div class="clearfix"></div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between">
              <h4 class="card-title">Список семестров</h4>
              <button class="btn btn-info btn-fill btn-sm" @click="fetchSemesters">
                <i class="bx bx-refresh"></i> Обновить
              </button>
            </div>
            <div class="card-body table-full-width table-responsive">
              <table class="table table-hover table-striped">
                <thead>
                <tr>
                  <th>№</th>
                  <th>Название</th>
                  <th>Дата начала</th>
                  <th>Дата окончания</th>
                  <th class="text-right">Действия</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="fetching"><td colspan="5" class="text-center">Загрузка данных...</td></tr>
                <tr v-if="!fetching && semesters.length === 0"><td colspan="5" class="text-center">Семестры не найдены</td></tr>

                <tr v-for="(sem, index) in semesters" :key="sem.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ sem.name }}</td>
                  <td>{{ formatDate(sem.startDate) }}</td>
                  <td>{{ formatDate(sem.endDate) }}</td>
                  <td class="text-right">
                    <button class="btn btn-danger btn-sm btn-fill" @click="deleteSemester(sem.id)">
                      <i class="bx bx-trash"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '../server';

export default {
  name: 'SemesterManager',
  data() {
    return {
      semesters: [],
      fetching: false,
      loading: false,
      successMessage: null,
      errorMessage: null,
      form: {
        name: '',
        startDate: '',
        endDate: ''
      }
    };
  },
  mounted() {
    this.fetchSemesters();
  },
  methods: {
    async fetchSemesters() {
      this.fetching = true;
      const token = localStorage.getItem('token');
      try {
        const response = await axios.get(`${API_URL}/api/semester`, {
          headers: { 'Authorization': `Bearer ${token}`, 'accept': '*/*' }
        });
        if (response.data.code === 200) {
          this.semesters = response.data.data || [];
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        this.fetching = false;
      }
    },

    async createSemester() {
      this.loading = true;
      this.errorMessage = null;
      this.successMessage = null;
      const token = localStorage.getItem('token');

      try {
        const response = await axios.post(`${API_URL}/api/semester`, this.form, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'accept': '*/*'
          }
        });

        if (response.data.code === 200) {
          this.successMessage = "Семестр успешно создан!";
          this.form = { name: '', startDate: '', endDate: '' }; // Reset form
          this.fetchSemesters(); // Refresh list
        } else {
          this.errorMessage = "Ошибка: " + (response.data.message || "Не удалось создать");
        }
      } catch (error) {
        this.errorMessage = "Ошибка сервера при создании семестра.";
      } finally {
        this.loading = false;
      }
    },

    async deleteSemester(id) {
      if (!confirm("Вы действительно хотите удалить этот семестр?")) return;

      const token = localStorage.getItem('token');
      try {
        const response = await axios.delete(`${API_URL}/api/semester/${id}`, {
          headers: { 'Authorization': `Bearer ${token}`, 'accept': '*/*' }
        });

        if (response.status === 200 || response.data.code === 200) {
          this.fetchSemesters();
        }
      } catch (error) {
        alert("Ошибка при удалении семестра");
        console.error(error);
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return '-';
      return new Date(dateStr).toLocaleDateString('ru-RU');
    }
  }
};
</script>

<style scoped>
.pull-right { float: right; }
.clearfix { clear: both; }
.d-flex { display: flex; }
.justify-content-between { justify-content: space-between; }
</style>
